// =======================
// 🧠 React та хуки
// =======================
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// =======================
// 📦 Зовнішні бібліотеки
// =======================
import Table from "antd/lib/table";
import Select from "antd/lib/select";
import Space from "antd/lib/space";
import Spin from "antd/lib/spin";
import Button from "antd/lib/button";
import { Empty } from "antd";
import LoadingOutlined from "@ant-design/icons/LoadingOutlined";
import PlusOutlined from "@ant-design/icons/PlusOutlined";
import DeleteOutlined from "@ant-design/icons/DeleteOutlined";

// =======================
// 🌐 Контексти
// =======================
import { SessionContext } from "../../contexts/session/index.context";
import { TranslationContext } from "../../contexts/translation/index.context";

// =======================
// ⚙️ Сервіси / API
// =======================
import { request } from "../../services";

// =======================
// 🧩 Утиліти / типи
// =======================
import { AdministrationProps } from "./types";
import { MergedColumnType } from "../ui/table/utils/types";
import { useTableColumns } from "../ui/table/utils";

// =======================
// 🎨 Стилі
// =======================
import styles from "./styles.module.scss";


export default function Administration(props: AdministrationProps) {
  console.log("Administration props", props)
  const location = useLocation();
  const { intl } = useContext(TranslationContext);
  const { tableState, setTableState, tableStateAccess, setTableStateAccess } =
    useContext(SessionContext);
  const [selectData, setSelectData] = useState<MergedColumnType[]>([]);
  const [tableData, setTableData] = useState<MergedColumnType[]>([]);
  const [tableDataAccess, setTableDataAccess] = useState<MergedColumnType[]>(
    []
  );

  const [param, setParam] = useState(undefined);
  const [idRowAccess, setIdRowAccess] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [loadingAccess, setLoadingAccess] = useState(false);
  const [reset, setReset] = useState(false);
  const [addButtonDisabled, setAddButtonDisabled] = useState(true);
  const [deleteButtonDisabled, setDeleteButtonDisabled] = useState(true);

  const selectOptions = selectData.map((item) => ({
    value: item.typeDocID,
    label: item.typeDocName,
  }));

  const isScroll =
    location.pathname.split("/")[1].includes("documents") ||
    location.pathname === "/directories/nomenclature-of-cases-current" ||
    location.pathname === "/directories/employees" ||
    location.pathname === "/directories/structural-units" ||
    location.pathname === "/directories/departmental-journals";

  useEffect(() => {
    fetchDataTable();
  }, []);

  const fetchSelectData = async () => {
    const content = (
      await request(`${location.pathname}/getdoctype`, {
        method: "get",
        cancelTokenKey: "getdoctype",
      })
    )?.content;
    setSelectData(content || []);
  };

  const onSelectChange = (value: number | undefined) => {
    fetchDataTable(value);
  };

  const fetchDataTable = async (id?: number) => {
    setLoading(true);
    const content = (
      await request(`${props.url || location.pathname}/getdatatable`, {
        method: "post",
        body: { id },
        cancelTokenKey: "getdatatable",
      })
    )?.content;
    const dataWithKeys =
      content?.map((item: any) => ({ ...item, key: item.id })) || [];
    setTableData(dataWithKeys || []);
    setLoading(false);
  };

  const fetchDataTableAccess = async (param?: string) => {
    setLoadingAccess(true);
    const content = (
      await request(`${location.pathname}/getdatatableaccess`, {
        method: "post",
        body: { param },
        cancelTokenKey: "getdatatableaccess",
      })
    )?.content;

    // const dataWithKeys =
    //   content?.map((item: any) => ({ ...item, key: item.id })) || [];
    setTableDataAccess(content);
    setLoadingAccess(false);
  };

  const onClickRow = async (record: any) => {
    fetchDataTableAccess(record.Param);
    setParam(record.Param);
    setTableState((prevState) => ({ ...prevState, selectedRow: record.id }));
    setAddButtonDisabled(false);
  };

  const handlePageSizeChange = (_current: number, size: number) => {
    setTableState((prevState) => ({ ...prevState, pageSize: size }));
  };

  const handleCurrentPageChange = (page: number) => {
    setTableState((prevState) => ({ ...prevState, currentPage: page }));
  };

  const handleAccessPageSizeChange = (_current: number, size: number) => {
    setTableStateAccess((prevState) => ({ ...prevState, pageSize: size }));
  };

  const handleAccessCurrentPageChange = (page: number) => {
    setTableStateAccess((prevState) => ({ ...prevState, currentPage: page }));
  };

  const onClickAdd = async () => {
    await request(`${location.pathname}/adddatatableaccess`, {
      method: "post",
      body: { param },
      cancelTokenKey: "adddatatableaccess",
    });
    fetchDataTableAccess(param);
  };

  const onClickRowAccess = async (record: any) => {
    setIdRowAccess(record.id);
    setDeleteButtonDisabled(false);
  };

  const onClickDelete = async () => {
    await request(`${location.pathname}/deletedatatableaccess`, {
      method: "post",
      body: { id: idRowAccess },
      cancelTokenKey: "deletedatatableaccess",
    });
    fetchDataTableAccess(param);
  };

  const onChange = async (id: number, checked: boolean) => {
    await request(`${location.pathname}/updateaccess`, {
      method: "post",
      body: { id, checked },
      cancelTokenKey: "updateaccess",
    });
    fetchDataTableAccess(param);
  };

  return (
    // <Space className={styles["space"]} align="start">
    <div style={{display: "flex", justifyContent: "space-between", padding: "10px 5px"}}>
      <div style={{display: "block", maxWidth: "800px"}}>
        <Select
        // size="small"
          showSearch
          allowClear
          style={{ width: "100%", marginBottom: "10px"}}
          placeholder={intl("document-type")}
          optionFilterProp="label"
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          onChange={onSelectChange}
          onDropdownVisibleChange={fetchSelectData}
          options={selectOptions}
        />
        <Table
          className={styles["table"]}
          dataSource={tableData}
          columns={useTableColumns(reset, setReset, undefined, tableData)}
          style={{height: "calc(100vh - 120px)"}}
          // scroll={{ x: "100vw", y: "calc(25vh - 100px)" }}
          locale={{
            emptyText: (
              <Empty 
                image={Empty.PRESENTED_IMAGE_SIMPLE} 
                description={intl("no-data")}
              />
            ),
          }}
          onRow={(record, index) => ({
            onClick: () => {
              onClickRow(record);
            },
          })}
          rowClassName={(record, index) => {
            return record.id === tableState.selectedRow
              ? styles["selected-row"]
              : "";
          }}
          pagination={{
            position: ["bottomCenter"],
            pageSize: tableState.pageSize || 15,
            pageSizeOptions: [15, 20, 50, 100],
            showSizeChanger: true,
            onShowSizeChange: handlePageSizeChange,
            current: tableState.currentPage,
            onChange: (page) => handleCurrentPageChange(page),
            locale: {
              items_per_page: intl("selector-page"), 
            },
          }}
          sticky={true}
          scroll={{ y: "calc(100vh - 200px)" }}
          loading={{
            spinning: loading,
            indicator: (
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              />
            ),
          }}
          size="small"
        />
      </div>
      <div style={{display: "block",  maxWidth: "650px"}}>
        <Space style={{ width: "100%", marginBottom: "10px", border: "1px solid lightgray", borderRadius: "5px", height: "32px"}}>
          <Button
            className={styles["button"]}
            onClick={onClickAdd}
            icon={<PlusOutlined />}
            disabled={addButtonDisabled}
          />
          <Button
            className={styles["button"]}
            onClick={onClickDelete}
            icon={<DeleteOutlined />}
            disabled={deleteButtonDisabled}
          />
        </Space>
        <Table
          className={styles["table"]}
          dataSource={tableDataAccess}
          style={{height: "calc(100vh - 120px)"}}
          locale={{
            emptyText: (
              <Empty 
                image={Empty.PRESENTED_IMAGE_SIMPLE} 
                description={intl("no-data")}
              />
            ),
          }}
          columns={useTableColumns(
            reset,
            setReset,
            undefined,
            tableDataAccess,
            true,
            onChange
          )}
          onRow={(record, index) => ({
            onClick: () => {
              onClickRowAccess(record);
            },
          })}
          rowClassName={(record, index) => {
            return record.id === idRowAccess ? styles["selected-row"] : "";
          }}
          pagination={{
            position: ["bottomCenter"],
            pageSize: tableStateAccess.pageSize || 15,
            pageSizeOptions: [15, 20, 50, 100],
            showSizeChanger: true,
            onShowSizeChange: handleAccessPageSizeChange,
            current: tableStateAccess.currentPage,
            onChange: (page) => handleAccessCurrentPageChange(page),
            locale: {
              items_per_page: intl("selector-page"), 
            },
          }}
          scroll={{ y: "calc(100vh - 200px)" }}
          loading={{
            spinning: loadingAccess,
            indicator: (
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              />
            ),
          }}
          size="small"
        />
      </div>
      {/* </Space> */}
    </div>
  );
}
